import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useRegistrationStore } from '~/stores/registration'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    const registrationStore = useRegistrationStore()

    if (
      to.name === 'registreren-actie' &&
      registrationStore.formProgress.collector.hasSubmitted
    ) {
      return navigateTo({
        name: 'account-actiepagina'
      })
    }
  }
})
